"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESportsCodes = exports.MainOutcomeTypes = void 0;
var MainOutcomeTypes;
(function (MainOutcomeTypes) {
    MainOutcomeTypes["W1"] = "\u041F1";
    MainOutcomeTypes["W1_X2"] = "\u041F1_x2";
    MainOutcomeTypes["WX"] = "\u0425";
    MainOutcomeTypes["W2"] = "\u041F2";
    MainOutcomeTypes["W2_X2"] = "\u041F2_x2";
    MainOutcomeTypes["W1X"] = "1\u0425";
    MainOutcomeTypes["W12"] = "12";
    MainOutcomeTypes["WX2"] = "\u04252";
    MainOutcomeTypes["HC1"] = "\u04241[]";
    MainOutcomeTypes["HC2"] = "\u04242[]";
    MainOutcomeTypes["TO"] = "\u0422\u043E\u0442\u0411[]";
    MainOutcomeTypes["TU"] = "\u0422\u043E\u0442\u041C[]";
    MainOutcomeTypes["TOO"] = "\u0422\u043E\u0442\u0411\u0441\u041E\u0422[]";
    MainOutcomeTypes["TUO"] = "\u0422\u043E\u0442\u041C\u0441\u041E\u0422[]";
    MainOutcomeTypes["HC1O"] = "\u04241\u0441\u041E\u0422[]";
    MainOutcomeTypes["HC2O"] = "\u04242\u0441\u041E\u0422[]";
})(MainOutcomeTypes || (exports.MainOutcomeTypes = MainOutcomeTypes = {}));
var ESportsCodes;
(function (ESportsCodes) {
    ESportsCodes["FOOTBALL"] = "Football";
    ESportsCodes["TENNIS"] = "Tennis";
    ESportsCodes["BASKETBALL"] = "Basketball";
    ESportsCodes["ICE_HOCKEY"] = "Hockey";
    ESportsCodes["VOLLEYBALL"] = "Volleyball";
    ESportsCodes["CYBER_SPORT"] = "Cybersport";
    ESportsCodes["MIXED_MARTIAL_ARTS"] = "Mixed_martial_arts";
    ESportsCodes["BOX"] = "Boxing";
    ESportsCodes["BASEBALL"] = "Baseball";
    ESportsCodes["BASKETBALL_3X3"] = "Basketball_3x3";
    ESportsCodes["TABLE_TENNIS"] = "Table_tennis";
    ESportsCodes["SHORT_HOCKEY"] = "Short_hockey";
    ESportsCodes["HANDBALL"] = "Handball";
    ESportsCodes["BILLIARDS"] = "Billiards";
    ESportsCodes["WATER_POLO"] = "Water_polo";
    ESportsCodes["BIATHLON"] = "Biathlon";
    ESportsCodes["CURLING"] = "Curling";
    ESportsCodes["BADMINTON"] = "Badminton";
    ESportsCodes["AUSTRALIAN_FOOTBALL"] = "Aussie_rules";
    ESportsCodes["AMERICAN_FOOTBALL"] = "American_football";
    ESportsCodes["DARTS"] = "Darts";
    ESportsCodes["FIELD_HOCKEY"] = "Field_hockey";
    ESportsCodes["HOCKEY_WITH_BALL"] = "Bandy";
    ESportsCodes["CYCLING"] = "Cycling";
    ESportsCodes["CYBER_BASKETBALL"] = "Cyberbasketball";
    ESportsCodes["CYBER_TENNIS"] = "Cybertennis";
    ESportsCodes["CYBER_FOOTBALL"] = "Cyberfootball";
    ESportsCodes["CYBER_HOCKEY"] = "Cyberhockey";
    ESportsCodes["CRICKET"] = "Cricket";
    ESportsCodes["MINI_FOOTBALL"] = "Mini_football";
    ESportsCodes["PESAPALLO"] = "Pesapallo";
    ESportsCodes["BEACH_VOLLEYBALL"] = "Beach_volleyball";
    ESportsCodes["BEACH_HANDBALL"] = "Beach_handball";
    ESportsCodes["BEACH_SOCCER"] = "Beach_football";
    ESportsCodes["RUGBY"] = "Rugby";
    ESportsCodes["RUGBY_7"] = "Rugby_sevens";
    ESportsCodes["RUGBY_UNION"] = "Rugby_union";
    ESportsCodes["RUGBY_LEAGUE"] = "Rugby_league";
    ESportsCodes["SEPAK_TAKRAW"] = "Sepaktakraw";
    ESportsCodes["FLOORBALL"] = "Floorball";
    ESportsCodes["FORMULA_1"] = "Formula_1";
    ESportsCodes["BALLS"] = "Bowls";
    ESportsCodes["FUTSAL"] = "Futsal";
    ESportsCodes["CHESS"] = "Chess";
    ESportsCodes["SHORT_TRACK"] = "Short_track";
    ESportsCodes["DTM"] = "DTM";
    ESportsCodes["NASCAR"] = "NASCAR";
    ESportsCodes["BOBSLED"] = "Bobsleigh";
    ESportsCodes["BOWLING"] = "Bowling";
    ESportsCodes["FREESTYLE_WRESTLING"] = "Freestyle_wrestling";
    ESportsCodes["GOLF"] = "Golf";
    ESportsCodes["ALPINE_SKIING"] = "Alpine_skiing";
    ESportsCodes["ROWING_ACADEMIC"] = "Rowing";
    ESportsCodes["ROWING_ON_KAYAKS_AND_CANOES"] = "Canoeing";
    ESportsCodes["GRECOROMAN_WRESTLING"] = "Greco_roman_wrestling";
    ESportsCodes["GAELIC_FOOTBALL"] = "Gaelic_football";
    ESportsCodes["DUATHLON"] = "Nordic_combined";
    ESportsCodes["KABBADI"] = "Kabbadi";
    ESportsCodes["HORSEBACK_RIDING"] = "Equestrian_sport";
    ESportsCodes["SKATING"] = "Speed_skating";
    ESportsCodes["LACROSSE"] = "Lacrosse";
    ESportsCodes["ATHLETICS"] = "Athletics";
    ESportsCodes["SKIING"] = "Cross_country_skiing";
    ESportsCodes["NORDIC_COMBINED"] = "Ski_nordic_combined";
    ESportsCodes["MOTORCYCLE_RACING"] = "Motorbikes";
    ESportsCodes["NETBALL"] = "Netball";
    ESportsCodes["SAILING"] = "Sailing";
    ESportsCodes["SWIMMING"] = "Swimming";
    ESportsCodes["DIVING"] = "Diving";
    ESportsCodes["SKI_JUMPING"] = "Ski_jumping";
    ESportsCodes["BULLET_SHOOTING"] = "Shooting";
    ESportsCodes["RALLY"] = "Rally";
    ESportsCodes["FISHING"] = "Fishing";
    ESportsCodes["SLED"] = "Luge";
    ESportsCodes["SYNCHRONIZED_SWIMMING"] = "Synchronized_swimming";
    ESportsCodes["HORSE_RACING"] = "Horse_racing";
    ESportsCodes["SQUASH"] = "Squash";
    ESportsCodes["SKATEBOARDING"] = "Skateboarding";
    ESportsCodes["SKELETON"] = "Skeleton";
    ESportsCodes["SNOWBOARDING"] = "Snowboarding";
    ESportsCodes["MODERN_PENTATHLON"] = "Modern_pentathlon";
    ESportsCodes["SOFTBALL"] = "Softball";
    ESportsCodes["SPEEDWAY"] = "Speedway";
    ESportsCodes["GYMNASTICS"] = "Gymnastics";
    ESportsCodes["ARCHERY"] = "Archery";
    ESportsCodes["PISTOL_SHOOTING"] = "Pistol_shooting";
    ESportsCodes["TRIATHLON"] = "Triathlon";
    ESportsCodes["WEIGHTLIFTING"] = "Weightlifting";
    ESportsCodes["FIGURE_SKATING"] = "Figure_skating";
    ESportsCodes["FREESTYLE"] = "Freestyle_skiing";
    ESportsCodes["MMA"] = "MMA";
    ESportsCodes["TEQBOL"] = "Teqball";
    ESportsCodes["AGE_OF_EMPIRES"] = "Age_of_Empires";
    ESportsCodes["APEX_LEGENDS"] = "Apex_legends";
    ESportsCodes["ARENA_OF_VALOR"] = "Arena_of_Valor";
    ESportsCodes["ARTIFACT"] = "Artifact";
    ESportsCodes["BRAWL_STARS"] = "Brawl_Stars";
    ESportsCodes["CALL_OF_DUTY"] = "Call_of_Duty";
    ESportsCodes["CLASH_ROYALE"] = "Clash_Royale";
    ESportsCodes["CROSSFIRE"] = "CrossFire";
    ESportsCodes["CS_GO"] = "CS_GO";
    ESportsCodes["CS2"] = "Counter_Strike_2";
    ESportsCodes["DOTA_2"] = "Dota_2";
    ESportsCodes["FORTNITE"] = "Fortnite";
    ESportsCodes["FREE_FIRE"] = "Free_Fire";
    ESportsCodes["GEARS_OF_WAR"] = "Gears_of_War";
    ESportsCodes["GWENT"] = "Gwent";
    ESportsCodes["HALO"] = "Halo";
    ESportsCodes["HEARTHSTONE"] = "Hearthstone";
    ESportsCodes["HEROES_OF_NEWERTH"] = "Heroes_of_Newerth";
    ESportsCodes["HEROES_OF_THE_STORM"] = "Heroes_of_the_Storm";
    ESportsCodes["KING_OF_GLORY"] = "King_of_Glory";
    ESportsCodes["LEAGUE_OF_LEGENDS"] = "League_of_Legends";
    ESportsCodes["LEAGUE_OF_LEGENDS_WILD_RIFT"] = "League_of_Legends_Wild_Rift";
    ESportsCodes["MOBILE_LEGENDS"] = "Mobile_Legends";
    ESportsCodes["MORTAL_KOMBAT_XL"] = "Mortal_Kombat_XL";
    ESportsCodes["OVERWATCH"] = "Overwatch";
    ESportsCodes["OVERWATCH_2"] = "Overwatch_2";
    ESportsCodes["PUBG"] = "PUBG";
    ESportsCodes["PUBG_MOBILE"] = "PUBG_Mobile";
    ESportsCodes["QUAKE"] = "Quake";
    ESportsCodes["RAINBOW_SIX"] = "Rainbow_Six";
    ESportsCodes["ROCKET_LEAGUE"] = "Rocket_League";
    ESportsCodes["STARCRAFT"] = "StarCraft";
    ESportsCodes["STARCRAFT_2"] = "StarCraft_2";
    ESportsCodes["STREET_FIGHTER"] = "Street_Fighter";
    ESportsCodes["STREET_FIGHTER_V"] = "Street_Fighter_V";
    ESportsCodes["TEKKEN_7"] = "Tekken_7";
    ESportsCodes["VAINGLORY"] = "VainGlory";
    ESportsCodes["VALORANT"] = "Valorant";
    ESportsCodes["WARCRAFT_III"] = "Warcraft_III";
    ESportsCodes["WORLD_OF_TANKS"] = "World_of_Tanks";
    ESportsCodes["WORLD_OF_WARCRAFT"] = "World_of_Warcraft";
    ESportsCodes["KARATE"] = "Karate";
    ESportsCodes["SLAP"] = "Slap";
    ESportsCodes["FIST_FIGHTING"] = "Fist_fighting";
    ESportsCodes["HURLING"] = "Hurling";
    ESportsCodes["PELOTA"] = "Pelota";
    ESportsCodes["PICKLEBALL"] = "Pickleball";
    ESportsCodes["CLASH_OF_CLANS"] = "Clash_of_Clans";
    ESportsCodes["SUMO"] = "Sumo";
})(ESportsCodes || (exports.ESportsCodes = ESportsCodes = {}));
//# sourceMappingURL=types.js.map